import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { CFooter, CNav, CNavItem, CNavLink } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import {
  cilHome,
  cilList,
  cilShieldAlt,
  cilMap,
  cilPhone,
  cilPen,
  cilInfo,
  cilLocationPin,
} from '@coreui/icons'

import * as cusUtil from 'src/viewsCommon/CusUtil'

const AppFooter = (param) => {
  const userPermission = cusUtil.checkUserPermission()
  console.log('userPermission ', userPermission)

  switch (userPermission) {
    case 'root':
    case 'admin':
    case 'cadmin':
    case 'cmanager':
      return (
        <CFooter className="small">
          <div>
            {/* <a href="https://coreui.io" target="_blank" rel="noopener noreferrer">
          Tobesmart
        </a>
        <span className="ms-1">&copy; 2023 Tobesmart.</span> */}
          </div>
          <div className="ms-auto">
            <span className="me-1">Powered by</span>
            {/* <a href="https://coreui.io/react" target="_blank" rel="noopener noreferrer">
          Tobesmart
        </a> */}
            <span className="ms-1">&copy; 2024 Tobesmart.</span>
          </div>
        </CFooter>
      )
    case 'user':
    default:
      const AppFooterUser = require('../viewsCus/_company/commonMenu/AppFooterUser').default
      return <AppFooterUser />
  }
}

export default React.memo(AppFooter)
